const SCOPE = 'save-pending-changes';

export const PendingChangesAuthorsMenuTestIds = {
  SELECT_ALL_BUTTON: `${SCOPE}.select-all-authors-button`,
  getAuthorCheckboxId: authorKey => `${SCOPE}.author-${String(authorKey).toLowerCase()}-checkbox`,
};
